import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const reportApi = createApi({
  reducerPath: "report",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token
      headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["reports"],
  endpoints: (builder) => ({
    dailyReport: builder.query({
      query: (data) => {
          return {
              url: "/Report/DailyReport",
              method: "GET",
              params: data
          }
      },
      providesTags: ["reports"],
    }),
    orderReport: builder.query({
      query: (data) => {
          return {
            url: "/Report/OrderReport",
            method: "GET",
            params: data
          }
      },
      providesTags: ["reports"],
    }),
    salesReport: builder.query({
      query: (data) => {
          return {
            url: "/Report/SalesReport",
            method: "GET",
            params: data
          }
      },
      providesTags: ["reports"],
    }),
    serviceProductReport: builder.query({
      query: (data) => {
          return {
            url: "/Report/GetServiceProdReport",
            method: "GET",
            params: data
          }
      },
      providesTags: ["reports"],
    }),
    customerOrderReport: builder.query({
      query: (data) => {
          return {
            url: "/Report/CustomerOrderReport",
            method: "GET",
            params: data
          }
      },
      providesTags: ["reports"],
    }),
    orderQueueReport: builder.query({
      query: (data) => {
        return {
          url: "/Report/GetOrderQueueReport",
          method: "GET",
          params: data
        }
      },
      providesTags: ["reports"],
    }),
    inventoryReport: builder.query({
      query: (data) => {
        return {
          url: "/Report/GetInventoryReport",
          method: "GET",
          params: data
        }
      },
      providesTags: ["reports"],
    }),
    getAllReports: builder.mutation({
      query: (data) => {
        return {
          url: `/Report/getAllReports?outletID=${data.outletID}`,
          method: "POST",
          body: data,
          responseHandler: (response) => response.blob(), // Handle response as blob
        }
      },
      providesTags: ["reports"],
    })
  }),
});

export const { 
  useDailyReportQuery, 
  useOrderReportQuery, 
  useSalesReportQuery, 
  useServiceProductReportQuery, 
  useCustomerOrderReportQuery, 
  useOrderQueueReportQuery,
  useInventoryReportQuery,
  useGetAllReportsMutation
} = reportApi;
